import { render, staticRenderFns } from "./podGi.vue?vue&type=template&id=fa052a8c&scoped=true&"
import script from "./podGi.vue?vue&type=script&lang=js&"
export * from "./podGi.vue?vue&type=script&lang=js&"
import style0 from "./podGi.vue?vue&type=style&index=0&id=fa052a8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa052a8c",
  null
  
)

export default component.exports